import React from 'react';
import {Text} from 'react-native';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';

export default () => (
  <>
    <Heading level={1}>Event Handlers</Heading>
    <Spacer size={16} />
    <Text>
      The <Code>onChange</Code> prop accepts a event handler which will be
      called when the <Code>Checkbox</Code> component is checked and unchecked,
      and this handler receive the updated checked state as argument.
    </Text>
    <Spacer size={16} />
    <FlexView>
      <Code>
        {'<Checkbox onChange={(checked) => checked ? doThis() : doThat()} />'}
      </Code>
    </FlexView>
  </>
);
